/* NR · Motor del PDP (Fase 4, mockup v3). Vanilla, sin dependencias.
   Módulos: galería (contador por scroll libre + miniaturas desktop + lightbox).
   T4/T5 agregan: variantes/tallas, guarda, urgencia, sticky ATC. */
(function () {
  'use strict';

  /* prefers-reduced-motion: los scroll suaves del motor lo respetan (veredicto H15, barrido web Jul 5) */
  var NRP_SCROLL = (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) ? 'auto' : 'smooth';

  function initGaleria(root) {
    var gal = root.querySelector('[data-nrp-galeria]');
    if (!gal) return;
    var rail = gal.querySelector('[data-nrp-rail]');
    var slides = rail ? Array.prototype.slice.call(rail.querySelectorAll('[data-nrp-slide]')) : [];
    if (!rail || !slides.length) return;

    var count = gal.querySelector('[data-nrp-count]');
    var thumbs = Array.prototype.slice.call(gal.querySelectorAll('[data-nrp-th]'));
    var total = slides.length;
    var current = 0;

    function stepWidth() {
      return slides[0].offsetWidth + (parseFloat(getComputedStyle(rail).columnGap || getComputedStyle(rail).gap) || 0);
    }

    function slideIndexFromScroll() {
      var step = stepWidth();
      if (!step) return 0;
      return Math.max(0, Math.min(total - 1, Math.round(rail.scrollLeft / step)));
    }

    function setCurrent(idx) {
      if (idx === current) return;
      current = idx;
      if (count) count.textContent = (idx + 1) + ' / ' + total;
      thumbs.forEach(function (th) {
        th.classList.toggle('is-on', Number(th.getAttribute('data-nrp-th')) === idx);
      });
    }

    var raf = null;
    rail.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        setCurrent(slideIndexFromScroll());
      });
    }, { passive: true });

    thumbs.forEach(function (th) {
      th.addEventListener('click', function () {
        var idx = Number(th.getAttribute('data-nrp-th')) || 0;
        rail.scrollTo({ left: idx * stepWidth(), behavior: NRP_SCROLL });
      });
    });

    /* lightbox (también lo usa la guía de tallas: root.__nrpOpenLb) */
    var lb = root.querySelector('[data-nrp-lightbox]');
    if (lb) {
      document.body.appendChild(lb); /* escapa del stacking context de la columna */
      var lbImg = lb.querySelector('[data-nrp-lb-img]');
      var lbClose = lb.querySelector('[data-nrp-lb-close]');

      /* gestión de foco del diálogo (veredicto H7, barrido web Jul 5 — patrón del drawer):
         foco a la ✕ al abrir, Tab atrapado, retorno al disparador al cerrar */
      var lbTrigger = null;
      var openLb = function (src) {
        if (lbImg && src) lbImg.setAttribute('src', src);
        lbTrigger = document.activeElement;
        lb.hidden = false;
        document.documentElement.style.overflow = 'hidden';
        if (lbClose) lbClose.focus();
      };
      var closeLb = function () {
        lb.hidden = true;
        document.documentElement.style.overflow = '';
        if (lbTrigger && lbTrigger.focus) lbTrigger.focus();
        lbTrigger = null;
      };
      lb.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab') return;
        /* a[href] estricto: [href] a secas matchea el <use href="#nr-x"> del ícono (no enfocable)
           y el trap no envuelve (retro-fix sesión F — mismo bug cazado en el takeover del quiz) */
        var focusables = lb.querySelectorAll('button, a[href], [tabindex]:not([tabindex="-1"])');
        if (!focusables.length) return;
        var first = focusables[0], last = focusables[focusables.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      });
      root.__nrpOpenLb = openLb;

      slides.forEach(function (slide) {
        slide.addEventListener('click', function () {
          openLb(slide.getAttribute('data-full'));
        });
      });
      if (lbClose) lbClose.addEventListener('click', closeLb);
      lb.addEventListener('click', function (e) { if (e.target === lb) closeLb(); });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !lb.hidden) closeLb();
      });
    }
  }

  /* ====== tallas: selección (NUNCA preseleccionada) + urgencia + guía ====== */
  function initTallas(root) {
    var wrap = root.querySelector('[data-nrp-tallas]');

    /* guía de tallas → abre el lightbox de la galería con la última foto */
    var guia = wrap && wrap.querySelector('[data-nrp-guia]');
    if (guia) {
      guia.addEventListener('click', function () {
        if (root.__nrpOpenLb) root.__nrpOpenLb(guia.getAttribute('data-full'));
      });
    }

    if (!wrap) return;
    var chips = Array.prototype.slice.call(wrap.querySelectorAll('[data-nrp-talla]'));
    var hint = wrap.querySelector('[data-nrp-hint]');
    var urg = wrap.querySelector('[data-nrp-urgencia]');
    var urgTxt = wrap.querySelector('[data-nrp-urgencia-txt]');
    var grid = wrap.querySelector('.nrp__tallas');
    var esTalla = wrap.getAttribute('data-es-talla') === '1';
    var optName = wrap.getAttribute('data-opt-name') || 'Talla';

    /* etiqueta del sticky: "Talla 9 US" (talla numérica) · "Talla M" (ropa) · "Sabor: Fresa" */
    function stickyLabel(valor) {
      if (esTalla) return /^\d/.test(valor) ? 'Talla ' + valor + ' US' : 'Talla ' + valor;
      return optName + ': ' + valor;
    }

    function seleccionar(chip) {
      chips.forEach(function (c) {
        c.classList.toggle('is-on', c === chip);
        c.setAttribute('aria-pressed', c === chip ? 'true' : 'false');
      });
      if (hint) hint.hidden = true;

      /* urgencia: ≤3 unidades de la variante elegida (solo con inventario rastreado) */
      var qty = Number(chip.getAttribute('data-qty'));
      var track = chip.getAttribute('data-track') === '1';
      var pocas = track && qty > 0 && qty <= 3;
      if (urg && urgTxt) {
        /* string canónico del glosario §15e (veredicto barrido Jul 5, H8) —
           des-ocultar ANTES de escribir: una región live oculta no anuncia su 1ª aparición */
        var sufijo = esTalla ? ' en tu talla' : ' disponibles';
        urg.hidden = !pocas;
        urgTxt.textContent = '¡Vuelan! Solo ' + (qty === 1 ? 'queda 1' : 'quedan ' + qty) + sufijo;
      }

      root.dispatchEvent(new CustomEvent('nrp:variant', {
        detail: {
          id: chip.getAttribute('data-variant-id'),
          label: stickyLabel(chip.getAttribute('data-talla')),
          sku: chip.getAttribute('data-sku'),
          price: chip.getAttribute('data-price'),
          qty: qty,
          track: track
        }
      }));
    }

    chips.forEach(function (chip) {
      if (chip.disabled) return;
      chip.addEventListener('click', function () { seleccionar(chip); });
    });

    /* deep-link ?variant= (catalog ads / links de Bruno): el cliente YA eligió su talla
       en el anuncio — respetarla NO es preselección (la regla Jul 4 aplica al default). */
    var vParam = new URLSearchParams(location.search).get('variant');
    if (vParam) {
      var match = chips.filter(function (c) { return c.getAttribute('data-variant-id') === vParam && !c.disabled; })[0];
      if (match) seleccionar(match);
    }

    /* guarda de talla: la usa el submit del form (T5) */
    root.__nrpGuardaTalla = function () {
      var elegida = chips.some(function (c) { return c.classList.contains('is-on'); });
      if (elegida) return true;
      if (hint) hint.hidden = false;
      if (grid) {
        grid.classList.remove('is-shake');
        void grid.offsetWidth; /* reinicia la animación */
        grid.classList.add('is-shake');
        grid.scrollIntoView({ behavior: NRP_SCROLL, block: 'center' });
      }
      return false;
    };
  }

  /* ====== form (guarda) + variante seleccionada + SKU ====== */
  function initForm(root) {
    var form = root.querySelector('[data-nrp-form]');
    if (!form) return;
    var input = form.querySelector('[data-nrp-variant-input]');
    var conTallas = form.hasAttribute('data-nrp-con-tallas');

    root.addEventListener('nrp:variant', function (e) {
      if (input) input.value = e.detail.id;
      var sku = root.querySelector('[data-nrp-sku]');
      if (sku && e.detail.sku) sku.textContent = 'SKU ' + e.detail.sku;
    });

    form.addEventListener('submit', function (e) {
      if (conTallas && (!input || !input.value)) {
        e.preventDefault();
        if (root.__nrpGuardaTalla) root.__nrpGuardaTalla();
        return;
      }
      /* Flip carrito 3/3 (Jul 6): agregar por AJAX + abrir el drawer NR (muere el
         redirect a /cart). Sin motor o con excepción de red → submit nativo intacto. */
      if (!window.NRCart || !window.fetch) return;
      e.preventDefault();
      var atc = form.querySelector('[data-nrp-atc]');
      var disparador = (document.activeElement && document.activeElement !== document.body) ? document.activeElement : atc;
      var atcHtml = atc ? atc.innerHTML : '';
      if (atc) { atc.disabled = true; atc.textContent = 'Agregando…'; }
      var restaurar = function () { if (atc) { atc.disabled = false; atc.innerHTML = atcHtml; } };
      var fd = new FormData(form);
      fd.append('sections', 'nr-cart-drawer');
      fetch('/cart/add.js', { method: 'POST', body: fd })
        .then(function (r) {
          if (!r.ok) {
            /* 422 (agotado/tope): la voz del server en el hint rojo del PDP (aria-live) */
            return r.json().catch(function () { return {}; }).then(function (j) {
              restaurar();
              var hint = root.querySelector('[data-nrp-hint]');
              if (hint) { hint.textContent = j.description || 'No se pudo agregar. Intenta de nuevo.'; hint.hidden = false; }
            });
          }
          /* add EXITOSO: nunca re-postear desde aquí (doble unidad) — si el parse/swap
             falla, navegar a /cart ya con el ítem dentro (re-run code-review Jul 16) */
          return r.json().then(function (j) {
            restaurar();
            try {
              if (j.sections && j.sections['nr-cart-drawer']) window.NRCart.swap(j.sections['nr-cart-drawer']);
              window.NRCart.open(disparador);
            } catch (err) { window.location.href = '/cart'; }
          }).catch(function () { restaurar(); window.location.href = '/cart'; });
        })
        .catch(function () { restaurar(); form.submit(); }); /* solo red caída ANTES del add */
    });
  }

  /* ====== ATC sticky contextual ====== */
  function initSticky(root) {
    var sticky = root.querySelector('[data-nrp-sticky]');
    var form = root.querySelector('[data-nrp-form]');
    if (!sticky || !form) return;
    document.body.appendChild(sticky); /* fijo al viewport, fuera del grid */

    var btn = sticky.querySelector('[data-nrp-sticky-btn]');
    var sub = sticky.querySelector('[data-nrp-sticky-sub]');
    var conTallas = form.hasAttribute('data-nrp-con-tallas');
    var seleccion = null;

    /* aparece cuando el ATC principal ya pasó (por arriba del viewport);
       entries puede traer varios cruces acumulados → manda el ÚLTIMO */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var en = entries[entries.length - 1];
        var paso = !en.isIntersecting && en.boundingClientRect.top < 0;
        sticky.hidden = !paso;
      }, { threshold: 0 });
      io.observe(form);
    }

    root.addEventListener('nrp:variant', function (e) {
      seleccion = e.detail;
      /* sticky SIN talla COL (regla Jul 4); label ya resuelto por el selector */
      if (sub) sub.textContent = seleccion.label;
      if (btn) {
        btn.textContent = 'Agregar · ' + (seleccion.price || btn.getAttribute('data-price'));
        btn.classList.remove('is-negro');
        btn.classList.add('is-amarillo');
      }
    });

    if (btn) {
      btn.addEventListener('click', function () {
        if (conTallas && !seleccion) {
          /* paso previo: llevar al selector (sin hint rojo en el sticky) */
          var tallas = root.querySelector('[data-nrp-tallas]');
          if (tallas) tallas.scrollIntoView({ behavior: NRP_SCROLL, block: 'center' });
          return;
        }
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.submit();
      });
    }
  }

  /* ====== stepper de cantidad ("−" deshabilitado en 1; "+" tope = inventario real
     de la variante elegida — veredicto P6, barrido web Jul 5; sin tope si no se rastrea) ====== */
  function initQty(root) {
    var qty = root.querySelector('[data-nrp-qty]');
    if (!qty) return;
    var menos = qty.querySelector('[data-nrp-qty-menos]');
    var mas = qty.querySelector('[data-nrp-qty-mas]');
    var input = qty.querySelector('[data-nrp-qty-input]');
    if (!menos || !mas || !input) return;

    /* tope inicial: variante única / inicial (atributos del wrapper, si el Liquid los trae) */
    var qty0 = Number(qty.getAttribute('data-qty'));
    var max = (qty.getAttribute('data-track') === '1' && qty0 > 0) ? qty0 : Infinity;

    function val() { return Math.max(1, parseInt(input.value, 10) || 1); }
    function set(n) {
      n = Math.min(Math.max(1, n), max);
      input.value = n;
      menos.disabled = n <= 1;
      mas.disabled = n >= max;
    }
    menos.addEventListener('click', function () { set(val() - 1); });
    mas.addEventListener('click', function () { set(val() + 1); });
    input.addEventListener('change', function () { set(val()); });

    /* al cambiar de talla, el tope sigue a la variante elegida */
    root.addEventListener('nrp:variant', function (e) {
      max = (e.detail.track && e.detail.qty > 0) ? e.detail.qty : Infinity;
      set(val());
    });
  }

  function init() {
    var root = document.querySelector('[data-nr-pdp]');
    if (!root || root.dataset.nrPdpBound) return;
    root.dataset.nrPdpBound = '1';
    initGaleria(root);
    initTallas(root);
    initForm(root);
    initQty(root);
    initSticky(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Editor de temas: la sección se re-renderiza → limpiar los nodos portados al body
     (lightbox / sticky quedarían huérfanos y duplicados) y re-inicializar. */
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:unload', function () {
      Array.prototype.slice.call(document.body.children).forEach(function (n) {
        if (n.hasAttribute && (n.hasAttribute('data-nrp-lightbox') || n.hasAttribute('data-nrp-sticky'))) n.remove();
      });
    });
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target && e.target.querySelector && e.target.querySelector('[data-nr-pdp]')) init();
    });
  }
})();
